<app-public-nav></app-public-nav>
<div class="jumbotron">
  <div class="jumbotron-body">
<!--    <div class="jumbotron-agency">-->
    <!--      <span class="jumbotron-agency-short">มกอช.</span>-->
    <!--      <span class="jumbotron-agency-name">ระบบค้นหาข้อมูลมาตรฐานสินค้าเกษตรและอาหาร</span>-->
    <!--    </div>-->
    @if (pageTitle()) {
      <h1 class="jumbotron-title">{{ pageTitle() }}</h1>
    }
  </div>
</div>
<div class="public-cover-layout py-3">
  <main class="public-cover-content">
    <router-outlet></router-outlet>
  </main>
</div>
<footer class="public-footer">
  <span>© 2026 สำนักงานมาตรฐานสินค้าเกษตรและอาหารแห่งชาติ (มกอช.)</span>
</footer>
